import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';

import './PriceTrackerSummary.scss';

export default class PriceTrackerSummary extends Component {

  static propTypes = {
    boardBasis: PropTypes.string.isRequired,
    destination: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    flightDetails: PropTypes.object,
    hotelName: PropTypes.string.isRequired,
    isCheapestFlight: PropTypes.bool,
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  render() {
    const {
      boardBasis,
      destination,
      duration,
      flightDetails,
      hotelName,
      isCheapestFlight,
    } = this.props;

    return (<div className="price-tracker-summary">
      <div className="price-tracker-summary__hotel-details">
        <h3 className="price-tracker-summary__hotel-details__hotel-name">{hotelName}</h3>
        <p>in {destination}</p>
        <p>{duration} nights, {boardBasis}</p>
      </div>

      { !!flightDetails && (<div className="price-tracker-summary__flight-details">
        <div className="price-tracker-summary__flight-details__outbound">
          <h3>Outbound:</h3>
          <p>{flightDetails.outboundDate}</p>
          <p>{flightDetails.outboundDepartureTime} {flightDetails.outboundDepartureName} - {flightDetails.outboundArrivalTime} {flightDetails.outboundArrivalName}</p>
        </div>
        <div className="price-tracker-summary__flight-details__inbound">
          <h3>Inbound:</h3>
          <p>{flightDetails.inboundDate}</p>
          <p>{flightDetails.inboundDepartureTime} {flightDetails.inboundDepartureName} - {flightDetails.inboundArrivalTime} {flightDetails.inboundArrivalName}</p>
        </div>
      </div>) }

      { isCheapestFlight && (<div className="price-tracker-summary__cheapest-flight">
        <h3>+ Cheapest Flight</h3></div>) }
    </div>);
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/PriceTrackerSummary/PriceTrackerSummary.jsx
 **/